import { useRef, useState, useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import roadesenseImage from "../images/roadsense-image.jpg";

// import useConfig from "../hooks/useConfig";
import ValidPassword from "../components/Register/ValidPassword";
import ValidUserName from "../components/Register/ValidUserName";
import axios from "../api/axios";
// import useAuth from "../hooks/authenticate/useAuth";
import useVerify from "../hooks/verify/useVerify";

const Register = () => {
  // let navigate = useNavigate();
  const { verify, setVerified } = useVerify();

  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState("");
  const [validName, setValidName] = useState(false);
  const [userFocus, setUserFocus] = useState(false);

  const [password, setPwd] = useState("");
  const [validPwd, setValidPwd] = useState(false);
  const [pwdFocus, setPwdFocus] = useState(false);

  const [matchPwd, setMatchPwd] = useState("");
  const [validMatch, setValidMatch] = useState(false);
  const [matchFocus, setMatchFocus] = useState(false);
  const [isSuccessFull, setisSuccessFull] = useState(false);

  const [errMsg, setErrMsg] = useState("");

  useEffect(() => {
    if (verify.isVerified) userRef.current.focus();
  }, [verify]);

  useEffect(() => {
    setValidName(ValidUserName(user));
  }, [user]);

  useEffect(() => {
    setValidPwd(ValidPassword(password));
    const match = password === matchPwd;
    setValidMatch(match);
  }, [password, matchPwd]);

  useEffect(() => {
    setErrMsg("");
  }, [user, password, matchPwd]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if button enabled with JS hack
    const v1 = ValidUserName(user);
    const v2 = ValidPassword(password);
    if (!v1 || !v2) {
      setErrMsg("Invalid Entry");
      return;
    }
    try {
      await axios
        .post(
          `v1/register?token=${verify.token}`,
          JSON.stringify({ user, password }),
          {
            headers: {
              // Overwrite Axios's automatically set Content-Type
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.status === 201) {
            setVerified(true);
            setTimeout(() => {
              setisSuccessFull(true);
            }, 500);
          } else {
            setTimeout(() => {
              setisSuccessFull(true);
            }, 500);
          }

          //clear state and controlled inputs
          //need value attrib on inputs for this
        });
    } catch (err) {
      if (!err?.response) {
        setErrMsg("No Server Response");
      } else if (err.response?.status === 409) {
        setErrMsg("Username Taken");
      } else {
        setErrMsg("Registration Failed");
      }
      errRef.current.focus();
    }
  };
  if (isSuccessFull) {
    return <Navigate to={"/"} replace />;
  }
  if (!verify.isVerified) return <Navigate to={"/login"} replace />;
  return (
    <>
      <div className="h-screen w-full flex items-center justify-center bg-sky-900   bg-opacity-25">
        <div className="  p-10 flex flex-col items-center bg-slate-100 rounded-lg">
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "hidden"}
            hidden
            aria-live="assertive"
          >
            {errMsg}
          </p>
          <h1 className="pb-10">
            {
              // eslint-disable-next-line jsx-a11y/alt-text
              <img className="max-h-8 max-w-xl flex" src={roadesenseImage} />
            }{" "}
          </h1>

          <form className=" w-100  p-10" onSubmit={handleSubmit}>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="text"
                name="username"
                id="username"
                ref={userRef}
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-gray-900 dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                autoComplete="off"
                required
                aria-describedby="uidnote"
                onChange={(e) => setUser(e.target.value)}
                value={user}
                aria-invalid={validName ? "false" : "true"}
                onFocus={() => setUserFocus(true)}
                onBlur={() => setUserFocus(false)}
              />
              <label
                htmlFor="username"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Username
              </label>

              <p className="invisible peer-focus:visible   text-gray-700 font-light text-xs">
                Please enter your name
                <br />
                4 to 24 characters.
                <br />
                Must begin with a letter.
                <br />
                Letters, numbers, underscores, hyphens allowed.
              </p>
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="password"
                name="floating_password"
                id="floating_password"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-gray-900 dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                autoComplete="off"
                onChange={(e) => setPwd(e.target.value)}
                value={password}
                required
                aria-invalid={validPwd ? "false" : "true"}
                aria-describedby="pwdnote"
                onFocus={() => setPwdFocus(true)}
                onBlur={() => setPwdFocus(false)}
              />
              <label
                htmlFor="floating_password"
                className="peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Password
              </label>
              <p
                id="pwdnote"
                className={
                  "invisible peer-focus:visible   text-gray-700 font-light text-xs"
                }
              >
                8 to 24 characters.
                <br />
                Must include uppercase and lowercase letters, a number and a
                special character.
                <br />
                Allowed special characters:{" "}
                <span aria-label="exclamation mark">!</span>{" "}
                <span aria-label="at symbol">@</span>{" "}
                <span aria-label="hashtag">#</span>{" "}
                <span aria-label="dollar sign">$</span>{" "}
                <span aria-label="percent">%</span>
              </p>
            </div>
            <div className="relative z-0 mb-6 w-full group">
              <input
                type="password"
                name="repeat_password"
                id="floating_repeat_password"
                autoComplete="off"
                className="block py-2.5 px-0 w-full text-sm text-gray-900 bg-transparent border-0 border-b-2 border-gray-300 appearance-none dark:text-dark dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                onChange={(e) => setMatchPwd(e.target.value)}
                value={matchPwd}
                required
                aria-invalid={validMatch ? "false" : "true"}
                aria-describedby="confirmnote"
                onFocus={() => setMatchFocus(true)}
                onBlur={() => setMatchFocus(false)}
              />
              <label
                htmlFor="floating_repeat_password"
                className=" peer-focus:font-medium absolute text-sm text-gray-500 dark:text-gray-900 duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-[0] peer-focus:left-0 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
              >
                Confirm password
              </label>
              <p
                id="confirmnote"
                className={
                  "invisible peer-focus:visible   text-gray-700 font-light text-xs"
                }
              >
                Must match the first password input field.
              </p>
            </div>

            <button
              type="submit"
              className={
                !validName || !validPwd || !validMatch
                  ? "text-white bg-red-700 hover:bg-blue-900 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800 opacity-50"
                  : "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
              }
              disabled={!validName || !validPwd || !validMatch ? true : false}
            >
              Submit
            </button>
          </form>

          {/* <form onSubmit={handleSubmit} className="">
              <div className="pb-3 px-24">
                <label className="px-10" htmlFor="username">
                  Username:
                  <input
                    className="px-2 py-1 rounded-lg peer"
                    type="text"
                    id="username"
                    ref={userRef}
                    autoComplete="off"
                    onChange={(e) => setUser(e.target.value)}
                    value={user}
                    required
                    aria-invalid={validName ? "false" : "true"}
                    aria-describedby="uidnote"
                    onFocus={() => setUserFocus(true)}
                    onBlur={() => setUserFocus(false)}
                  />
                  <p
                    id="uidnote"
                    className={
                      "px-4 invisible peer-placeholder-shown:::visible "
                    }
                  >
                    4 to 24 characters.
                    <br />
                    Must begin with a letter.
                    <br />
                    Letters, numbers, underscores, hyphens allowed.
                  </p>
                </label>
              </div>
              <div className="px-16">
                <label className="px-14" htmlFor="password">
                  Password:
                </label>
                <input
                  className="px-2 py-1 rounded-lg"
                  type="password"
                  id="password"
                  onChange={(e) => setPwd(e.target.value)}
                  value={pwd}
                  required
                  aria-invalid={validPwd ? "false" : "true"}
                  aria-describedby="pwdnote"
                  onFocus={() => setPwdFocus(true)}
                  onBlur={() => setPwdFocus(false)}
                />
                <p id="pwdnote" className={"px-4"}>
                  8 to 24 characters.
                  <br />
                  Must include uppercase and lowercase letters, a number and a
                  special character.
                  <br />
                  Allowed special characters:{" "}
                  <span aria-label="exclamation mark">!</span>{" "}
                  <span aria-label="at symbol">@</span>{" "}
                  <span aria-label="hashtag">#</span>{" "}
                  <span aria-label="dollar sign">$</span>{" "}
                  <span aria-label="percent">%</span>
                </p>
              </div>
              <div className="px-24">
                <label className="px-2" htmlFor="confirm_pwd">
                  Confirm Password:
                </label>
                <input
                  className="px-2 py-1 rounded-lg"
                  type="password"
                  id="confirm_pwd"
                  onChange={(e) => setMatchPwd(e.target.value)}
                  value={matchPwd}
                  required
                  aria-invalid={validMatch ? "false" : "true"}
                  aria-describedby="confirmnote"
                  onFocus={() => setMatchFocus(true)}
                  onBlur={() => setMatchFocus(false)}
                />
                <p
                  id="confirmnote"
                  className={
                    matchFocus && !validMatch ? "instructions" : "offscreen"
                  }
                >
                  Must match the first password input field.
                </p>
              </div>

              <button
                disabled={!validName || !validPwd || !validMatch ? true : false}
              >
                Sign Up
              </button>
            </form> */}
        </div>
      </div>
    </>
  );
};
export default Register;
